<template>
    <div>
        <page-title>{{ $t('promotions.list_page_title') }}</page-title>
        <promotion-table>
            <template v-slot:actions>
                <create-button
                    :route-name="routeType.PROMOTION_CREATE"
                ></create-button>
            </template>
        </promotion-table>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import PageTitle from '@/components/layout/components/pageTitle'
import PromotionTable from '@/components/pages/promotion/Table'
import CreateButton from '@/components/form/Actions/CreateButton'

export default {
    components: {
        CreateButton,
        PageTitle,
        PromotionTable,
    },
    data() {
        return {
            routeType,
        }
    },
}
</script>
